module.exports = __webpack_public_path__ + "static/img/dingding.4c93b6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/dingding.png
// module id = 4DUp
// module chunks = 0